import { createContext, useContext } from 'react';

export const ContextTheme = createContext([]);

export const ContextMenu = createContext([]);

export const useContextMenu = () => useContext(ContextMenu);

export const useContextTheme = () => useContext(ContextTheme);
